var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@lucidlink/uicore';
import { ModalTestIdFactory } from '@lucidlink/uicore/interactions';
export const ModalTitle = ({ children, id, }) => {
    return (_jsx(Typography, { align: "center", as: "h2", color: "accent", "data-testid": ModalTestIdFactory.getModalTitleBase(), id: id, kind: "h4", children: children }));
};
_react_refresh_temp_1 = ModalTitle;
$RefreshReg$(_react_refresh_temp_1, "ModalTitle");
